// src/scripts/contact/internal/dependencies.js

import { isBrowser } from './constants.js';
import { debugHelpers } from './debugHelpers.js';
import { waitForDOMReady } from './domReady.js';

export async function loadContactDependencies() {
  if (!isBrowser) return false;
  await waitForDOMReady();
  try {
    await import('../utils/goToTextareaBegin.js');
    debugHelpers.log('Loaded contact dependencies');
    return true;
  } catch (err) {
    debugHelpers.log('Dependency load failed', { err });
    return false;
  }
}